<template>
<div class="card">
  <div class="elr-card-inner">
    <div class="elr-card-header">
      <figure class="elr-card-full-image" v-if="item.image">
        <router-link :to="`/pony/${item.pony_id}`">
          <img :src="`/pony-images/${item.image.image_path}`" :alt="item.name">
        </router-link>
      </figure>
    </div>
    <div class="elr-card-body">
      <div class="elr-card-content">
          <div class="card-item-header">
              <h2 class="elr-card-title">
                  <router-link :to="`/pony/${item.pony_id}`">{{item.name}}</router-link>
              </h2>
              <h3 v-if="item.notes" class="elr-card-subtitle">{{item.notes}}</h3>
          </div>
          <ul class="card-details">
              <!-- wishlist item details -->
          </ul>
      </div>
    </div>
    <div class="elr-card-footer" v-if="user">
      <div class="elr-card-actions">
        <button class="elr-button elr-button-danger" @click="edit">Edit Item</button>
        <button class="elr-button elr-button-danger" @click="remove">Delete Item</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {showPrompt} from '../../utils/helpers'
export default {
  name: 'WishlistItemCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      image: null
    };
  },
  methods: {
    edit() {
      // show edit wishlist item view
    },
    remove() {
      showPrompt();

      // remove wishlist item from database
      // remove wishlist item from view
    }
  }
};
</script>
